import { Routes } from '@angular/router';
import { DashboardLayoutPageComponent } from './pages/dashboard-layout-page/dashboard-layout-page.component';
import { DashboardPageComponent } from './pages/dashboard-page/dashboard-page.component';
import { ListComponent } from './components/list/list.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { UserListComponent } from './pages/user-list/user-list.component';
import { VenueDetailsListComponent } from './pages/venue-details-list/venue-details-list.component';
import { CountryListPageComponent } from './pages/country-list-page/country-list-page.component';
import { CountryFormPageComponent } from './pages/country-form-page/country-form-page.component';
import { StateListPageComponent } from './pages/state-list-page/state-list-page.component';
import { StateFormPageComponent } from './pages/state-form-page/state-form-page.component';
import { DivisionFormPageComponent } from './pages/division-form-page/division-form-page.component';
import { DivisionListPageComponent } from './pages/division-list-page/division-list-page.component';
import { CityListPageComponent } from './pages/city-list-page/city-list-page.component';
import { DistrictListPageComponent } from './pages/district-list-page/district-list-page.component';
import { AcademicYearListPageComponent } from './pages/academic-year-list-page/academic-year-list-page.component';
import { StreamListPageComponent } from './pages/stream-list-page/stream-list-page.component';
import { ProgramListPageComponent } from './pages/program-list-page/program-list-page.component';
import { UniversityListPageComponent } from './pages/university-list-page/university-list-page.component';
import { DriveListPageComponent } from './pages/drive-list-page/drive-list-page.component';
import { CollegeListPageComponent } from './pages/college-list-page/college-list-page.component';
import { SubjectListPageComponent } from './pages/subject-list-page/subject-list-page.component';
import { EvaluationPageComponent } from './pages/evaluation-page/evaluation-page.component';
import { TalukhaPageComponent } from './pages/talukha-page/talukha-page.component';
import { PermissionPageComponent } from './pages/permission-page/permission-page.component';
import { RolePageComponent } from './pages/role-page/role-page.component';
import { RolePermissionMappingComponent } from './pages/role-permission-mapping/role-permission-mapping.component';
import { CoursePageComponent } from './pages/course-page/course-page.component';
import { AssessmentPageComponent } from './pages/assessment-page/assessment-page.component';
import { EvaluatorListPageComponent } from './pages/evaluator-list-page/evaluator-list-page.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { MasterComponent } from './pages/master/master.component';
import { ExamListPageComponent } from './pages/exam-list-page/exam-list-page.component';
import { EvaluatedScriptListComponent } from './pages/evaluated-script-list/evaluated-script-list.component';
import { ModuleListPageComponent } from './pages/module-list-page/module-list-page.component';
import { SubModuleListComponent } from './pages/sub-module-list/sub-module-list.component';
import { StudentScriptsListPageComponent } from './pages/student-scripts-list-page/student-scripts-list-page.component';
import { LevelListPageComponent } from './pages/level-list-page/level-list-page.component';
import { StudentPortalListPageComponent } from './pages/student-portal-list-page/student-portal-list-page.component';
import { AddScriptComponent } from './pages/add-script/add-script.component';
import { TransactionHistoryListPageComponent } from './pages/transaction-history-list-page/transaction-history-list-page.component';
import { ReEvaluationsListPageComponent } from './pages/re-evaluations-list-page/re-evaluations-list-page.component';
import { PaymentPageComponent } from './components/payment-page/payment-page.component';
import { StudentPortalMasterComponent } from './pages/student-portal-master/student-portal-master.component';
import { AssessmentFormPageComponent } from './pages/assessment-form-page/assessment-form-page.component';
import { BarcodeMappingComponent } from './pages/barcode-mapping/barcode-mapping.component';
import { RolePermissionFormPageComponent } from './pages/role-permission-form-page/role-permission-form-page.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { ScriptListPageComponent } from './pages/script-list-page/script-list-page.component';
import { AddScriptFormPageComponent } from './pages/add-script-form-page/add-script-form-page.component';
import { StudentUserComponent } from './components/student-user/student-user.component';
import { authGuard } from './auth.guard';
import { ExamResultListComponent } from './pages/exam-result-list/exam-result-list.component';
import { EvaluatorMappingListPageComponent } from './pages/evaluator-mapping-list-page/evaluator-mapping-list-page.component';
import { HeadEvaluatorMappingListPageComponent } from './pages/head-evaluator-mapping-list-page/head-evaluator-mapping-list-page.component';
import { PaymentHistoryComponent } from './pages/payment-history/payment-history.component';
import { FacultyFormPageComponent } from './pages/faculty-form-page/faculty-form-page.component';
import { StudentMappingListPageComponent } from './pages/student-mapping-list-page/student-mapping-list-page.component';
import { ActivityLogListPageComponent } from './pages/activity-log-list-page/activity-log-list-page.component';

export const routes: Routes = [
    { path: 'sign-in', component: LoginPageComponent },

    {
        path: '', component: DashboardLayoutPageComponent,
        canActivate: [authGuard],
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            { path: 'dashboard', component: DashboardPageComponent },
            // { path: 'master', component: MasterComponent },
            { path: 'country/list', component: CountryListPageComponent },
            { path: 'country/form', component: CountryFormPageComponent },
            { path: 'state/list', component: StateListPageComponent },
            { path: 'state/form', component: StateFormPageComponent },
            { path: 'division/list', component: DivisionListPageComponent },
            { path: 'division/form', component: DivisionFormPageComponent },
            { path: 'university/list', component: UniversityListPageComponent },
            { path: 'college/list', component: CollegeListPageComponent },
            { path: 'drive/list', component: DriveListPageComponent },
            { path: 'list', component: ListComponent },
            { path: 'evalution', component: EvaluationPageComponent },
            { path: 'app-pagination', component: PaginationComponent },
            { path: 'user/list', component: UserListComponent },
            { path: 'user/student-list', component: StudentUserComponent },
            { path: 'course/list', component: CoursePageComponent },
            { path: 'city/list', component: CityListPageComponent },
            { path: 'assessment/list', component: AssessmentPageComponent },
            { path: 'assessment/form', component: AssessmentFormPageComponent },
            { path: 'evaluator/list', component: EvaluatorListPageComponent },
            { path: 'module/list', component: ModuleListPageComponent },
            { path: 'sub-module/list', component: SubModuleListComponent },
            { path: 'evaluator-srcript/list', component: EvaluatedScriptListComponent },
            { path: 'taluka/list', component: TalukhaPageComponent },
            { path: 'district/list', component: DistrictListPageComponent },
            { path: 'academic-year/list', component: AcademicYearListPageComponent },
            { path: 'stream/list', component: StreamListPageComponent },
            { path: 'program/list', component: ProgramListPageComponent },
            { path: 'permission/list', component: PermissionPageComponent },
            { path: 'role/list', component: RolePageComponent },
            { path: 'role-permission-mapping/list', component: RolePermissionMappingComponent },
            { path: 'subject/list', component: SubjectListPageComponent },
            { path: 'venue/details/list', component: VenueDetailsListComponent },
            { path: 'exam/list', component: ExamListPageComponent },
            { path: 'script/list', component: StudentScriptsListPageComponent },
            { path: 'level/list', component: LevelListPageComponent },
            { path: 'student-portal/list', component: StudentPortalListPageComponent },
            { path: 'payment-page', component: PaymentPageComponent },
            { path: 'transaction-history/list', component: TransactionHistoryListPageComponent },
            { path: 're-evaluations/list', component: ReEvaluationsListPageComponent },
            { path: 'add-script/list', component: AddScriptComponent },
            { path: 'add-script/form', component: AddScriptFormPageComponent },
            { path: 'student-master', component: StudentPortalMasterComponent },
            { path: 'evaluation-master', component: MasterComponent },
            { path: 'script-master', component: MasterComponent },
            { path: 'barcode-mapping/list', component: BarcodeMappingComponent },
            { path: 'student-mapping/list', component: StudentMappingListPageComponent },
            { path: 'role-permission/form', component: RolePermissionFormPageComponent },
            { path: 'reset-password', component: ResetPasswordComponent },
            { path: 'evaluation/script/list', component: ScriptListPageComponent },
            { path: 'exam-result/list', component: ExamResultListComponent },
            { path: 'evaluator-mapping/list', component: EvaluatorMappingListPageComponent },
            { path: 'head-evaluator-mapping/list', component: HeadEvaluatorMappingListPageComponent },
            { path: 'payment-history/list', component: PaymentHistoryComponent },
            { path: 'faculty/form', component: FacultyFormPageComponent },
            { path: 'activity-log/list', component: ActivityLogListPageComponent },
            { path: '**', redirectTo: 'dashboard' },

        ]

    }
];
